/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {
    AssetQualityLevel,
    IQualityExtensionSettings,
    IResourcesGroupConfig
} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";

export class TeslaGameAssets {
    //SPECIAL
    public static GAUGE_CRACK_ANIMATION:string = "gaugeGlassTween";


    //Frames:
    public static INTRO_BACKGROUND_LANDSCAPE:string = "intro_background";
    public static INTRO_BACKGROUND_PORTRAIT:string = "intro_background_portrait";

    public static INTRO_SCATTER:string = "introScatter";
    public static INTRO_FS_WILD:string = "introFsWild";
    public static INTRO_BONUS:string = "introBonus";

    public static INTRO_SCATTER_TEXT:string = "introScatterText";
    public static INTRO_FS_WILD_TEXT:string = "introFsWildText";
    public static INTRO_BONUS_TEXT:string = "introBonusText";

    public static MAIN_GAME_LANDSCAPE:string = "background/main_landscape_background";
    public static MAIN_GAME_PORTRAIT:string = "background/main_portrait_background";
    public static MAIN_GAME_OVERLAY_LANDSCAPE:string = "fx/main_landscape_overlay";
    public static MAIN_GAME_OVERLAY_PORTRAIT:string = "fx/main_portrait_overlay";
    public static REEL_FOREGROUND:string = "reel_foreground_portrait";

    public static FRAME_ALL:string = "tesla_Frame_Lighten";
    public static WILD_DISCHARGE:string = "wildDischarge";
    public static BIG_WIN_BG_EFFECT:string = "bigWin/bgEffect";
    public static WINDOW_TOP_FRAME:string = "background/window_top_frame";
    public static BIG_WIN_PARTICLE:string = "bigWin/particles";
    public static COLLECT_BOX_BACKPLATE:string = "collect/fuseboard";
    public static FS_TEXT:string = "fsIntro/freespins_text";
    public static TESLA_SPINS_PLAYED:string = "fsIntro/teslaSpinsPlayed";
    public static FS_TEXT_OVERLAY:string = "fsIntro/freespins_text_overlay";
    public static GAUGE_CRACKED:string = "fx/gauge/gauge_cracked";
    public static GAUGE_PIN:string = "fx/gauge/tesla_Gauge_Pin";
    public static GAUGE_LIGHT:string = "fx/gauge/gaugeLight";
    public static GAUGE_LIGHT_EFFECT:string = "fx/gauge/gaugeLightEffect";
    public static REEL_BACKGROUND:string = "reel_background";
    public static ROUND_AMBIENT_LIGHT:string = "fx/round_ambient_light";

    public static INITIAL_WIN_PARTICLES_BIG:string = "initialWinEffect/particles1";
    public static INITIAL_WIN_PARTICLES_MEDIUM:string = "initialWinEffect/particles2";
    public static INITIAL_WIN_PARTICLES_SMALL:string = "initialWinEffect/particles3";

    //animations
    public static JOLT_LOGO:string = "fsJoltLogo";
    public static FRAME_BOTTOM_RIGHT:string = "frameBottomRight";
    public static FRAME_LEFT:string = "frameLightLeft";
    public static FRAME_RIGHT:string = "frameLightRight";
    public static FRAME_TOP:string = "frameLightTop";
    public static FS_LOGO_EXPLOSION:string = "fsLogoExplosion";
    public static FS_SWITCH:string = "fsSwitch";

    public static ENERGY_BALL:string = "energyBall";
    public static RING_ELECTRO:string = "ringElectro";
    public static RING_EFFECT:string = "ringEffect";
    public static RADIAL_EFFECT:string = "radialEffect";
    public static RADIAL_RAYS:string = "radialRays";


    public static NEAR_WIN_ANIMATION:string = "nearWinReelDivider";

    public static BIW_WIN_TEXT_JOLTING:string = "jolting";
    public static BIW_WIN_TEXT_ELECTRIFYING:string = "electrifying";
    public static BIW_WIN_TEXT_SHOCKING:string = "shocking";
    public static PURPLE_LIGHTNING:string = "purpleLightning";
    public static COLLECT_BOX_COVER:string = "collectCover";
    public static COLLECT_BALL_ANIMATION:string = "collectBallAnimation";
    public static FS_SPIRAL:string = "freespinSpiralEffect";
    public static FS_PAPER_ANIMATION:string = "freespinPaperAnimation";

    public static BACKGROUND_WINDOW:string = "bgWindowAnimation";

    public static LIGHTNING_EFFECT:string = "lightningEffect";

    public static RADIAL_GLARE:string = "radialGlare";
    public static SELECTION_CIRCLE_EFFECT:string = "selectionCircleEffect";

    public static TINY_EFFECT:string = "tinyWinEffect";
    public static SMALL_EFFECT:string = "smallWinEffect";
    public static MEDIUM_EFFECT:string = "mediumWinEffect";
    public static LARGE_EFFECT:string = "largeWinEffect";


    private static TESLA_QUALITY_EXT:IQualityExtensionSettings = {
        medium : "@0.6x.",
        low : "@0.35x."
    };

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ]
            },
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("tesla-bm-font", "fonts/bitmapfonts/tesla-bm-font.fnt"),
                ]
            },
            {
                name : "introJpeg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json"),
                ]
            },
        ],
        main : [
            {
                name : "highQualityPng",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("highQualityPng0", "sheets/highQualityPng/highQualityPng0.json")
                ],
                animations : {
                    L1_normal : "L1",
                    L2_normal : "L2",
                    L3_normal : "L3",
                    L4_normal : "L4",
                    L5_normal : "L5",
                    M1_normal : "M1",
                    M2_normal : "M2",
                    M3_normal : "M3",
                    M4_normal : "M4",
                    B2_normal : "B2",
                    W2_normal : "W2",
                    B_normal : "B",
                    W_normal : "W",
                    S_normal : "S",

                    L1_noWin : "L1_dim",
                    L2_noWin : "L2_dim",
                    L3_noWin : "L3_dim",
                    L4_noWin : "L4_dim",
                    L5_noWin : "L5_dim",
                    M1_noWin : "M1_dim",
                    M2_noWin : "M2_dim",
                    M3_noWin : "M3_dim",
                    M4_noWin : "M4_dim",
                    B2_noWin : "B2_dim",
                    W2_noWin : "W2_dim",
                    B_noWin : "B_dim",
                    W_noWin : "W_dim",
                    S_noWin : "S_dim",
                }
            },
            {
                name : "highQualityJpeg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("highQualityJpeg0", "sheets/highQualityJpeg/highQualityJpeg0.json")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main1", "sheets/main/main1.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main2", "sheets/main/main2.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main3", "sheets/main/main3.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main4", "sheets/main/main4.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main5", "sheets/main/main5.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main6", "sheets/main/main6.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main7", "sheets/main/main7.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main8", "sheets/main/main8.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main9", "sheets/main/main9.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main10", "sheets/main/main10.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main11", "sheets/main/main11.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main12", "sheets/main/main12.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main13", "sheets/main/main13.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main14", "sheets/main/main14.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("main15", "sheets/main/main15.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                ],
                animations : {
                    L1_spin : "symbols/L1/L1_spin",
                    L2_spin : "symbols/L2/L2_spin",
                    L3_spin : "symbols/L3/L3_spin",
                    L4_spin : "symbols/L4/L4_spin",
                    L5_spin : "symbols/L5/L5_spin",
                    M1_spin : "symbols/M1/M1_spin",
                    M2_spin : "symbols/M2/M2_spin",
                    M3_spin : "symbols/M3/M3_spin",
                    M4_spin : "symbols/M4/M4_spin",
                    B2_spin : "symbols/B2/B2_spin",
                    W2_spin : "symbols/W2/W2_spin",
                    B_spin : "symbols/B/B_spin",
                    W_spin : "symbols/W/W_spin",
                    S_spin : "symbols/S/S_spin",

                    L1_win : "symbols/L1/L1_win/l1_win_",
                    L2_win : "symbols/L2/L2_win/L2_",
                    L3_win : "symbols/L3/L3_win/l3_",
                    L4_win : "symbols/L4/L4_win/l4_win_",
                    L5_win : "symbols/L5/L5_win/l5_win_",
                    M1_win : "symbols/M1/M1_win/M1_win_",
                    M2_win : "symbols/M2/M2_win/m2_win_",
                    M3_win : "symbols/M3/M3_win/m3_win_",
                    M4_win : "symbols/M4/M4_win/M4_win_",
                    B2_win : "symbols/B2/B2_win/clock_",
                    W2_win : "symbols/W2/W2_win/wild_win_pruple_",
                    W_win : "symbols/W/W_win/wild_win_",
                    B_win : "symbols/B/B_win/BONUS_ball_",
                    S_win : "symbols/S/S_win/S_win_",

                    W2_attention : "symbols/W2/W2_stop/wild2_stop",
                    W_attention : "symbols/W/W_stop/wild_stop_",
                    S_attention : "symbols/S/S_stop/S_stop_",


                    [TeslaGameAssets.TINY_EFFECT] : "symbols/genericSymbolWin/tiny/Small_explosion_",
                    [TeslaGameAssets.SMALL_EFFECT] : "symbols/genericSymbolWin/small/small_",
                    [TeslaGameAssets.MEDIUM_EFFECT] : "symbols/genericSymbolWin/medium/med_win_",
                    [TeslaGameAssets.LARGE_EFFECT] : "symbols/genericSymbolWin/big/big win_",

                    frameBottomRight : "reelArea/frame_lighten_bottom_right/frame_lighten_bottom_right_",
                    frameLightLeft : "reelArea/frame_lighten_left/frame_lighten_left_",
                    frameLightRight : "reelArea/frame_lighten_middle_right/frame_lighten_middle_right_",
                    frameLightTop : "reelArea/frame_lighten_top/frame_lighten_top_",
                    fsLogoExplosion : "reelArea/logoExplosion/logo_explosion_",
                    fsSwitch : "reelArea/switch/SWITCH_",

                    energyBall : "bigwin/energyBall/energy_ball_",
                    ringElectro : "fx/lightning/ringElectroEffect/Ring_Electr_effect_",

                    jolting : "bigwin/bigWinTexts/jolting/jolting_",
                    electrifying : "bigwin/bigWinTexts/electrifying/electrifying_",
                    shocking : "bigwin/bigWinTexts/shocking/shocking_",

                    collectCover : "collect/fuseBoxOpen/FS_Anime_",
                    collectBallAnimation : "collect/collectBall/Fuse ball_",

                    freespinSpiralEffect : "fsIntro/fsWinEffect/fs_spiral_effect_",
                    freespinPaperAnimation : "fsIntro/paperAnimation/paper_",

                    bgWindowAnimation : "background/window/window_",
                    gaugeGlassTween : "fx/gauge/gauge_glass/gauge_glass_",

                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json", true, TeslaGameAssets.TESLA_QUALITY_EXT),
                ],
                animations : {
                    radialRays : "bigWin/radialRays/Radial_rays_",
                    radialEffect : "Radial_effect/radial_effect_",
                    betLine : "betline/betline_",
                    nearWinReelDivider : "reelAttention/attention_",
                    ringEffect : "bigWin/ring/Ring_",
                    fsJoltLogo : "joltLogo/jolt_",
                    radialGlare : "glare/glare_",
                    purpleLightning : "lightning/purple/purple_lightning_",

                    [TeslaGameAssets.LIGHTNING_EFFECT] : "lightning/blue/lightning_",
                    [TeslaGameAssets.SELECTION_CIRCLE_EFFECT] : "selectionCircleEffect/selection_circle_effect_",
                }
            }
        ]
    }
}